import React from 'react'
import {
  IconButton,
  Grid,
  Dialog,
  DialogContent,
  Button,
  DialogActions,
  Tooltip,
} from '@mui/material'
import { useState } from '@hookstate/core'
import { DispatchSearchBox } from '../DispatchSearchBox'
import { SearchRounded } from '@mui/icons-material'
import { useLang } from '~/hooks/useLang'

export function SearchBoxButton({ canSearch = true }) {
  const { translate } = useLang()
  const isSearchDialog = useState(false)

  const handleClose = () => {
    isSearchDialog.set(!isSearchDialog.get())
  }

  return (
    <>
      <Grid item>
        <Tooltip
          title={translate('Search Dispatch')}
          componentsProps={{
            tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
          }}
        >
          <span style={{ display: 'inline-block' }}>
            <IconButton disabled={!canSearch} onClick={() => handleClose()}>
              <SearchRounded />
            </IconButton>
          </span>
        </Tooltip>
      </Grid>
      <Dialog
        onClose={handleClose}
        open={isSearchDialog.get()}
        maxWidth={'xs'}
        fullWidth
      >
        <DialogContent>
          <DispatchSearchBox isOpen={isSearchDialog} isValid={canSearch} />
        </DialogContent>
        <DialogActions sx={{ px: 3, gap: 1 }}>
          <Button variant="outlined" onClick={() => handleClose()}>
            {translate('Cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
